var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaposteAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5627_641)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_5627_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6832 64H0V10.0081H69.6832V64Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1847 21.6001H47.475C48.881 21.6001 49.8122 23.2108 49.0393 24.5553L47.7543 26.7915H32.218L22.0777 22.1697C21.7611 22.0249 21.8449 21.6001 22.1847 21.6001Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2227 28.7756H57.5269C57.8202 28.7756 58.0996 29.0044 58.0996 29.3499C58.0996 29.6533 57.8947 29.8494 57.6852 29.9054L11.9002 42.3378C11.6022 42.4218 11.3881 42.0344 11.6395 41.8336L32.2227 28.7756Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4002 36.1147L40.4076 39.5835C39.5462 41.0821 37.656 42.0111 36.0451 42.0438L19.4332 42.3519L42.4002 36.1147Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2241 52.6135H23.5583C23.1067 52.6135 22.9484 52.5902 22.7761 52.2494L22.4223 51.5491H18.8327L18.2973 52.6135H17.0495L20.0432 46.8198H21.2304L24.2241 52.6135ZM21.8962 50.508L20.6251 47.9823L19.3541 50.508H21.8962Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6927 50.9003V52.6137H26.5287V46.8713C27.1387 46.8573 27.9627 46.834 28.6425 46.834C29.9694 46.834 30.8493 47.0207 31.3754 47.5483C31.6967 47.8844 31.8643 48.3373 31.841 48.7995C31.841 50.4568 30.5513 50.9096 28.7077 50.9096C28.4562 50.9096 27.986 50.9003 27.6927 50.9003ZM27.6927 49.8359C27.9814 49.8405 28.3492 49.8452 28.6052 49.8452C29.3502 49.8452 30.0299 49.8219 30.3931 49.4577C30.5607 49.2896 30.6491 49.0562 30.6352 48.8181C30.6398 48.622 30.57 48.4306 30.4396 48.2812C30.0765 47.9171 29.5457 47.8937 28.6052 47.8937C28.3492 47.8937 27.9814 47.8984 27.6927 47.9078V49.8359Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3834 49.7422C39.3834 51.3856 38.0891 52.7255 35.9195 52.7255C33.7499 52.7255 32.4602 51.3856 32.4602 49.7422C32.4602 48.0989 33.7499 46.759 35.9195 46.759C38.0891 46.759 39.3834 48.0989 39.3834 49.7422ZM35.9195 47.8048C34.6065 47.8048 33.6707 48.5658 33.6707 49.7422C33.6707 50.9187 34.6065 51.6844 35.9195 51.6844C37.237 51.6844 38.1729 50.9187 38.1729 49.7422C38.1729 48.5658 37.237 47.8048 35.9195 47.8048Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6956 48.3183C44.1322 47.9495 43.4711 47.7488 42.796 47.7394C42.0976 47.7394 41.4458 47.9448 41.4458 48.4117C41.4458 49.5182 45.3753 48.8832 45.3753 50.9234C45.3753 52.0532 44.1695 52.7255 42.7262 52.7255C41.8043 52.7255 40.645 52.3987 39.928 51.9085L40.5193 51.0214C41.1991 51.4883 42.0045 51.7404 42.8286 51.7451C43.4432 51.7451 44.1648 51.5396 44.1648 51.0541C44.1648 49.859 40.2167 50.6059 40.2167 48.5938C40.2167 47.5247 41.362 46.759 42.8193 46.759C43.5921 46.759 44.6118 47.0065 45.2403 47.4033L44.6956 48.3183Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3254 47.9353H49.1186V52.6132H47.9593V47.9353H45.7897V46.8662H51.3254V47.9353Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0288 46.8662V47.9353H53.2111V49.1491H56.7122V50.2136H53.2111V51.5488H57.1359V52.6132H52.4661C52.2007 52.6132 52.0518 52.4405 52.0518 52.1977V46.8662H57.0288Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6554 51.5488H16.9238L16.3744 52.6132H12.9105C12.6451 52.6132 12.4962 52.4405 12.4962 52.1977V46.8662H13.6554V51.5488Z",
    fill: "#003DA5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5627_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.992 51.9947H16V21.0081H55.992V51.9947Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7321 27.6609H43.2465C44.0534 27.6609 44.5878 28.5853 44.1443 29.3569L43.4068 30.6403H34.4903L28.6706 27.9878C28.4889 27.9047 28.537 27.6609 28.7321 27.6609Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.493 31.7791H49.0154C49.1837 31.7791 49.344 31.9103 49.344 32.1086C49.344 32.2828 49.2264 32.3953 49.1062 32.4275L22.8296 39.5625C22.6586 39.6108 22.5357 39.3884 22.68 39.2732L34.493 31.7791Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.334 35.991L39.1904 37.9817C38.696 38.8418 37.6112 39.375 36.6867 39.3937L27.153 39.5706L40.334 35.991Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9025 45.4598H29.5204C29.2612 45.4598 29.1703 45.4464 29.0715 45.2508L28.8684 44.8489H26.8083L26.501 45.4598H25.7849L27.503 42.1348H28.1844L29.9025 45.4598ZM28.5665 44.2514L27.837 42.8019L27.1076 44.2514H28.5665Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8932 44.4765V45.4599H31.2252V42.1643C31.5752 42.1562 32.0481 42.1428 32.4383 42.1428C33.1998 42.1428 33.7048 42.25 34.0067 42.5528C34.1911 42.7457 34.2873 43.0056 34.2739 43.2708C34.2739 44.222 33.5338 44.4819 32.4757 44.4819C32.3314 44.4819 32.0615 44.4765 31.8932 44.4765ZM31.8932 43.8656C32.0588 43.8683 32.2699 43.871 32.4169 43.871C32.8444 43.871 33.2345 43.8576 33.4429 43.6486C33.5391 43.5522 33.5899 43.4182 33.5819 43.2815C33.5845 43.169 33.5445 43.0592 33.4696 42.9734C33.2612 42.7644 32.9566 42.751 32.4169 42.751C32.2699 42.751 32.0588 42.7537 31.8932 42.7591V43.8656Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6026 43.812C38.6026 44.7551 37.8597 45.5241 36.6146 45.5241C35.3694 45.5241 34.6293 44.7551 34.6293 43.812C34.6293 42.8688 35.3694 42.0999 36.6146 42.0999C37.8597 42.0999 38.6026 42.8688 38.6026 43.812ZM36.6146 42.7C35.8611 42.7 35.324 43.1368 35.324 43.812C35.324 44.4871 35.8611 44.9266 36.6146 44.9266C37.3708 44.9266 37.9078 44.4871 37.9078 43.812C37.9078 43.1368 37.3708 42.7 36.6146 42.7Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6513 42.9948C41.328 42.7831 40.9486 42.6679 40.5611 42.6625C40.1603 42.6625 39.7862 42.7804 39.7862 43.0483C39.7862 43.6833 42.0414 43.319 42.0414 44.4898C42.0414 45.1382 41.3494 45.5241 40.521 45.5241C39.992 45.5241 39.3267 45.3365 38.9152 45.0552L39.2545 44.5461C39.6446 44.814 40.1069 44.9587 40.5798 44.9614C40.9325 44.9614 41.3467 44.8435 41.3467 44.5648C41.3467 43.8789 39.0808 44.3076 39.0808 43.1528C39.0808 42.5393 39.7381 42.0999 40.5745 42.0999C41.018 42.0999 41.6032 42.2419 41.9639 42.4696L41.6513 42.9948Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4563 42.7749H44.1897V45.4596H43.5244V42.7749H42.2792V42.1614H45.4563V42.7749Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7295 42.1614V42.7749H46.5384V43.4716H48.5478V44.0825H46.5384V44.8488H48.7909V45.4596H46.1109C45.9586 45.4596 45.8731 45.3605 45.8731 45.2212V42.1614H48.7295Z",
    fill: "#003DA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.837 44.8488H25.7128L25.3975 45.4596H23.4095C23.2572 45.4596 23.1717 45.3605 23.1717 45.2212V42.1614H23.837V44.8488Z",
    fill: "#003DA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5627_641",
    x: -50,
    y: -39.9919,
    width: 169.683,
    height: 153.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_5627_641"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5627_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5627_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 31,
    fill: "white",
    transform: "translate(16 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaposteAppIcon);
export default __webpack_public_path__ + "static/media/laposte-app-icon.401b7a7cc561a105752496ef305d3460.svg";
export { ForwardRef as ReactComponent };